import { ToggleGroup } from 'radix-ui';
import { Fragment } from 'react';
import { cn } from '@/lib/cn';

export type Segment<V extends string> = { value: V; label: string; /** Draw a divider before this segment (Track sits behind one). */ dividerBefore?: boolean; disabled?: boolean };

type Props<V extends string> = {
  value: V; onChange: (v: V) => void; options: Segment<V>[]; 'aria-label': string; size?: 'sm' | 'md'; className?: string;
};

/** Single-select segmented control (mode switch, scope switch, theme). Radix ToggleGroup underneath: roving focus, arrow keys. */
export function SegmentedControl<V extends string>({ value, onChange, options, size = 'md', className, ...aria }: Props<V>) {
  return (
    <ToggleGroup.Root type="single" value={value} onValueChange={(v) => v && onChange(v as V)} aria-label={aria['aria-label']}
      className={cn('inline-flex items-center gap-1 p-1 rounded-btn bg-inset', className)}>
      {options.map((o) => (
        <Fragment key={o.value}>
          {o.dividerBefore && <span aria-hidden="true" className="w-px self-stretch my-1 mx-1 bg-toggle-off" />}
          <ToggleGroup.Item value={o.value} disabled={o.disabled}
            className={cn(
              'rounded-input border-0 cursor-pointer font-bold transition-colors text-ink-2 hover:text-ink data-[state=on]:bg-seg-on-bg data-[state=on]:text-seg-on-fg disabled:opacity-50',
              size === 'sm' ? 'h-[26px] px-[10px] text-[12px]' : 'h-[30px] px-[14px] text-row-title',
            )}>
            {o.label}
          </ToggleGroup.Item>
        </Fragment>
      ))}
    </ToggleGroup.Root>
  );
}
